var letter = "https://shopfront-cdn.tekoapis.com/static/95bf036e0047e5de.svg";

export { letter as default };
